import './src/index.less';
import { withInstall } from '@mts-fe/utils';
import basicModal from './src/BasicModal.vue';
import _SimpleModal from './src/SimpleModal.vue';

export const BasicModal = withInstall(basicModal);
export const SimpleModal = withInstall(_SimpleModal);
export { useModal, useModalInner } from './src/hooks/useModal';
export { useModalContext } from './src/hooks/useModalContext';
export * from './src/typing';
